// AdminLoginForm.js
import React, { useState } from 'react';

function AdminLoginForm() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    const handleSubmit = (event) => {
        event.preventDefault();
        // Check if username and password match (you can replace this with an API call or any other authentication method)
        if (username === '1' && password === '1') {
            // Set token or any other authentication method
            localStorage.setItem('adminLoggedIn', true);
            window.location.href = '/admin';
        } else if (username === '' || password === '') {
            setError('Plese fill both fields');
        }
        else {
            setError('Invalid username or password');
        }
    };

    return (
        <div className="flex justify-center items-center h-screen bg-gradient-to-r from-primary to-white">
            <form
                className="bg-white p-10 rounded-lg shadow-lg w-1/2"
                onSubmit={handleSubmit}
            >
                <h1 className="text-center text-2xl font-bold mb-5">Login as Admin</h1>
                <label className='text-primary '>Username:</label>
                <input
                    className="border mb-5 border-gray-300 p-2 rounded-lg w-full"
                    type="text"
                    value={username}
                    onChange={(event) => setUsername(event.target.value)}
                />
                <br />
                <label className='text-primary'>Password:</label>
                <input
                    className="border border-gray-300 p-2 rounded-lg w-full"
                    type="password"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                />
                <br />
                {error && (
                    <p className="text-red-500 text-center mt-5">{error}</p>
                )}
                <button
                    className="bg-primary text-white p-2 mt-5 rounded-lg w-full"
                    type="submit"
                >
                    Login
                </button>
            </form>
        </div>
    );
}

export default AdminLoginForm;